import { Component, OnInit } from '@angular/core';

import { AccountDetailsService } from '../services/account-details.service';
import { LoginService } from '../services/login.service';
import { AccountDetails } from '../models/AccountDetail';
import { AccountDeviceModel } from '../models/AccountDevicesModel';
import { CurrentAccount } from '../models/AccountModel';
import { UserInfoModel } from '../models/UserInfoModel';
import { ApiResponse } from '../models/APIResponse';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login-info-container',
  templateUrl: './login-info-container.component.html',
  styleUrls: ['./login-info-container.component.css']
})
export class LoginInfoContainerComponent implements OnInit {
  acctDetails: AccountDetails;
  customerInfo: UserInfoModel;
  accountsWithDevices: AccountDeviceModel;
  currentAccount: CurrentAccount;
  userName: string;
  userEmail: string;
  showConfimation = false;
  userNotFound: boolean;
  message: string;
  acctIndexID: any;

  constructor(
    private loginService: LoginService,
    private accountDetailsService: AccountDetailsService,
    private router: Router

  ) { }

  ngOnInit() {
    this.loginService.getUserContext()
      .subscribe((ctx) => {
        if (ctx) {
          this.acctIndexID = this.getActiveAcctIndex(ctx.accountsWithDevices, ctx.activeAcctId);
          this.userName = ctx.UserName;
          this.userEmail = ctx.accountDetails[this.acctIndexID].accountDetails.email;
        }
      });
  }
  getActiveAcctIndex(accts, activeAcctID) {
    var acctIDIndex = 0;

    //get correct acct based on selected active acctid
    for (var i = 0; i < accts.length; i++) {
      let acct = accts[i];
      if (acct.accountId == activeAcctID) {
        acctIDIndex = i;
        break;
      }
    }
    return acctIDIndex;
  }
  confirmResetPW() {
    this.showConfimation = true;
  }
  cancelResetPW() {
    this.showConfimation = false;
  }
  updatePW() {
    this.router.navigate(['/Login/Reset'], { queryParams: { username: this.userName} });
  }
  forgetPassword() {
    this.userNotFound = false;
    this.message = "";
    this.loginService.resetPassword(this.userName)
      .subscribe((res: ApiResponse) => {
        if (res.success) {
          this.router.navigate(['/Login'], { queryParams: { resetmsg: 'Email with reset instructions has been sent to your account email address!' } });
        } else {
          this.userNotFound = true;
          this.message = res.message;
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/login-info-container/login-info-container.component.ts